import script from "./View1Component.vue?vue&type=script&setup=true&lang=ts"
export * from "./View1Component.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__